export default {
  SET_entities(state, payload) {
    state.entities = payload
  },
}
